import CommonService from '../../services/common.service';
import {
  COMMON_NOTIFICATION,
  GET_COUNTRIES,
  SHOW_LOADER, 
  HIDE_LOADER 

} from '../constants';



export const setCommonNotification = (message = {}) => {
  return {
    type: COMMON_NOTIFICATION,
    payload: message,
  };
};

export const getCountries = () => async (dispatch) => {
  try {
    const resultData = await CommonService.getCountries();
    dispatch({
      type: GET_COUNTRIES,
      payload: resultData?.data?.length ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const showLoader = () => ({
  type: SHOW_LOADER,
});

export const hideLoader = () => ({
  type: HIDE_LOADER,
});